import { create } from "zustand";

import type { RankingOrder, RankingResultCount, RankingTimeframe } from "../../../types/callRanking";
import { ALL_AGENTS, DEFAULT_RANKING_COUNT } from "../../../types/callRanking";

type RestoreParams = Pick<FindBestWorstCallsState, "lens" | "attribute" | "timeframe" | "agent" | "resultCount"> & {
  order: RankingOrder;
};

export interface FindBestWorstCallsState {
  order: RankingOrder | null;
  lens: string | null;
  attribute: string | null;
  timeframe: RankingTimeframe;
  agent: string;
  resultCount: RankingResultCount;

  setOrder: (order: RankingOrder) => void;
  setLens: (lens: string | null) => void;
  setAttribute: (attribute: string | null) => void;
  setTimeframe: (timeframe: RankingTimeframe) => void;
  setAgent: (agent: string) => void;
  setResultCount: (count: RankingResultCount) => void;
  isValid: () => boolean;
  resetWizard: () => void;
  restoreFromParams: (params: RestoreParams) => void;
}

const initialState = {
  order: null as RankingOrder | null,
  lens: null as string | null,
  attribute: null as string | null,
  timeframe: "last7Days" as RankingTimeframe,
  agent: ALL_AGENTS,
  resultCount: DEFAULT_RANKING_COUNT
};

export const useFindBestWorstCallsStore = create<FindBestWorstCallsState>((set, get) => ({
  ...initialState,

  setOrder: (order: RankingOrder) => set({ order }),

  setLens: (lens: string | null) => set({ lens, attribute: null }),

  setAttribute: (attribute: string | null) => set({ attribute }),

  setTimeframe: (timeframe: RankingTimeframe) => set({ timeframe }),

  setAgent: (agent: string) => set({ agent }),

  setResultCount: (count: RankingResultCount) => set({ resultCount: count }),

  isValid: () => {
    const { order, lens } = get();
    return order !== null && lens !== null;
  },

  resetWizard: () => set({ ...initialState }),

  restoreFromParams: (params: RestoreParams) => set({
    order: params.order,
    lens: params.lens,
    attribute: params.attribute,
    timeframe: params.timeframe,
    agent: params.agent,
    resultCount: params.resultCount
  })
}));
